export default __webpack_public_path__ + "static/media/hands_message.b8b89a4e.svg";